import { render, staticRenderFns } from "./CommentsSection.vue?vue&type=template&id=73ba0120&"
import script from "./CommentsSection.vue?vue&type=script&lang=js&"
export * from "./CommentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports